import React from 'react';

import { Box, Flex, Text } from '@rover/kibble/core';
import type { SimplifiedArea } from '@rover/rsdk/src/apiClient/latest/model/simplifiedArea';

type Props = {
  simplifiedArea: SimplifiedArea;
  outlineColor: string;
};

const formatPercent = (ratio: number): string => `${(ratio * 100).toFixed(1)}%`;

const SimplifiedAreaLegend = ({ simplifiedArea, outlineColor }: Props): JSX.Element => {
  const { originalVertexCount, simplifiedVertexCount, vertexReductionRatio, reAddedAreaRatio } =
    simplifiedArea;

  return (
    <Box
      position="absolute"
      bottom="2x"
      left="2x"
      zIndex="1"
      padding="2x"
      background="primary"
      borderRadius="primary"
      variant="elevation_low"
      data-testid="simplified-area-legend"
    >
      <Flex flexDirection="row" alignItems="center" gap="2x">
        <Box
          width="16px"
          height="0px"
          borderWidth="2px"
          borderStyle="solid"
          borderColor={outlineColor}
        />
        <Text size="50" fontWeight="semibold">
          Simplified area preview
        </Text>
      </Flex>
      <Box>
        <Text size="50" textColor="secondary">
          Vertices {originalVertexCount} to {simplifiedVertexCount} (
          {formatPercent(vertexReductionRatio)} fewer)
        </Text>
      </Box>
      <Box>
        <Text size="50" textColor="secondary">
          Area added outside the original {formatPercent(reAddedAreaRatio)}
        </Text>
      </Box>
    </Box>
  );
};

export default SimplifiedAreaLegend;
